import { render } from "./ImpressumView.vue?vue&type=template&id=3452ba8a&scoped=true"
const script = {}

import "./ImpressumView.vue?vue&type=style&index=0&id=3452ba8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3452ba8a"]])

export default __exports__